import axios from "axios";
import {
  CLEAR_ERRORS,
  GET_ERRORS,
  GET_SHOPPINGCART_ORDERS,
  SET_ORDERS_LOADING
} from "./types";

// Get Stripe orders
export const getShoppingCartOrders = page => dispatch => {
  axios
    .get("/api/stripe/orders", { params: { page: page } })
    .then(res => {
      dispatch({
        type: CLEAR_ERRORS,
        payload: {}
      });
      dispatch({
        type: GET_SHOPPINGCART_ORDERS,
        payload: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ERRORS,
        payload: error.response ? error.response.data : { message: error.message }
      });
    });
};

export const syncStripeOrders = page => dispatch => {
  dispatch(setOrderLoading());

  return axios
    .post("/api/stripe/orders/sync")
    .then(res => {
      const summary = res.data || {};
      dispatch({
        type: CLEAR_ERRORS,
        payload: {}
      });
      dispatch(getShoppingCartOrders(page));
      return summary;
    })
    .catch(error => {
      const payload = error.response ? error.response.data : { message: error.message };
      dispatch({
        type: GET_ERRORS,
        payload
      });
      throw payload;
    });
};

export const refreshStripeOrders = page => dispatch => {
  dispatch(setOrderLoading());

  return axios
    .post("/api/stripe/orders/repair")
    .then(res => {
      const summary = res.data || {};
      dispatch({
        type: CLEAR_ERRORS,
        payload: {}
      });
      dispatch(getShoppingCartOrders(page));
      return summary;
    })
    .catch(error => {
      const payload = error.response ? error.response.data : { message: error.message };
      dispatch({
        type: GET_ERRORS,
        payload
      });
      throw payload;
    });
};

export const deleteStripeOrder = (orderId, page) => dispatch => {
  dispatch(setOrderLoading());

  return axios
    .delete(`/api/stripe/orders/${orderId}`)
    .then(res => {
      dispatch({
        type: CLEAR_ERRORS,
        payload: {}
      });
      dispatch(getShoppingCartOrders(page));
      return res.data;
    })
    .catch(error => {
      const payload = error.response ? error.response.data : { message: error.message };
      dispatch({
        type: GET_ERRORS,
        payload
      });
      throw payload;
    });
};

export const getSyncState = () => dispatch => {
  return axios
    .get("/api/stripe/orders/sync-state")
    .then(res => res.data)
    .catch(() => null);
};

export const getStripeSyncSummary = () => dispatch => {
  return axios
    .get("/api/stripe/orders/sync-state/summary")
    .then(res => res.data)
    .catch(() => null);
};

export const getSchedulerStatus = () => dispatch => {
  return axios
    .get("/api/stripe/orders/scheduler-status")
    .then(res => res.data)
    .catch(() => null);
};

export const setOrderLoading = () => dispatch => {
  dispatch({
    type: CLEAR_ERRORS,
    payload: {}
  });
  dispatch({
    type: SET_ORDERS_LOADING
  });
};
